/// \file routes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import { Route } from "react-router-dom";

import ErrorPage from "../views/error";
import NotFoundPage from "../views/notFoundPage";
import Home from "../views/home";
import Layout from "../components/layouts/mainLayout";

import authRoutes from './authRoutes'
import adminRoutes from './adminRoutes'
import fleetRoutes from './fleetRoutes'
import accountSubscriptions from "./accountSubscriptions";
import releaseNotes from "./releaseNotes";
import accountRoutes from "./accountRoutes";
import systemNotifications from "./systemNotifications";
import securityRoutes from "./securityRoutes";
const routes = (
  <Route
    path='/'
    element={ <Layout/> }
    errorElement={ <ErrorPage/> }
    handle={{
      id: '-1',
      text: 'Home',
      action: `/admin/customers/-1/manage`
    }}
    >
    <Route
      index
      element={ <Home/> }
    />
    {authRoutes}
    {adminRoutes}
    {fleetRoutes}
    {accountSubscriptions}
    {releaseNotes}
    {accountRoutes}
    {systemNotifications}
    {securityRoutes}
    <Route path='*' element={ <NotFoundPage/> } />
  </Route>
);

export default routes;